<template>
  <div :id="'section-' + item.id">
    <h3 class="line_title_box">{{item.index}} {{ item.name }}</h3>
    <div v-if="item.intro">
      <template v-for="(e, i) in item.intro" :key="i">
        <p class="section_text" v-html="e"></p>
      </template>
    </div>
    <div ref="nodeOperationRef">
      <div v-if="is_online && item.process_report.length>0 && item.process_report[0].task_name" style="margin: 40px 0;">
        <template v-if="isDisabled">
          <!-- <div class="line_history_box">
            <div class="collapse_head">
              <div class="collapse_h_left"></div>
              <div class="collapse_h_right">
                <HistorySwitch :item_data="item" @selectData="selectData"></HistorySwitch>
              </div>
              <div></div>
            </div>
          </div> -->

          <div class="custom_collapse_title" style="width: 100%;">
            <div class="flex custom_col_label">
              <!--  <img src="../NewStatus/img/Frame_1.png" alt="">
              <span class="title_text">分析配置</span> -->
            </div>
            <div class="flex" style="gap: 24px;">
              <template v-if="currentTask">
                <template v-for="status in statusList" :key="status.value">
                  <el-popover placement="bottom" :width="800" trigger="click">
                    <template #reference>
                      <div class="flex status_btn" :class="status.class" @click.stop="handleTaskClick(status.value)">
                        <img :src="status.icon" alt="">
                        <span>
                          {{ status.label }}（{{ currentTask.count[status.value] || 0 }}）
                        </span>
                      </div>
                    </template>
                    <NodeTaskTable v-if="currentTaskTable && currentTaskTable.length" :item_data="item_data"
                      :tableData="currentTaskTable" @selectData="selectData" />
                    <el-empty v-else description="暂无数据" />
                  </el-popover>
                </template>
              </template>
            </div>
          </div>

        </template>
        <template v-else>
          <el-collapse v-model="activeNames">
            <el-collapse-item title="参数配置" name="1" :disabled="isDisabled"
              :class="isDisabled?'custom_collapse_item':''">


              <!-- <template #title>
                <div class="collapse_head">
                  <div class="collapse_h_left">
                    <el-icon style="vertical-align: middle;font-size: 1.2rem;vertical-align: middle;">
                      <Setting />
                    </el-icon>
                    <span style="vertical-align: middle;">参数配置</span>
                  </div>
                  <div class="collapse_h_right">
                    <HistorySwitch :item_data="item" @selectData="selectData"></HistorySwitch>
                  </div>
                  <div></div>
                </div>
              </template> -->


              <template #title="{ isActive }">
                <div class="custom_collapse_title">
                  <div class="flex custom_col_label">
                    <!--  <img src="../NewStatus/img/Frame_1.png" alt=""> -->
                    <span class="title_text">分析配置</span>
                  </div>
                  <div class="flex" style="gap: 24px;">
                    <template v-if="currentTask">
                      <template v-for="status in statusList" :key="status.value">
                        <el-popover placement="bottom" :width="800" trigger="click">
                          <template #reference>
                            <!-- <div class="flex status_btn" :class="status.class"
                              @click.stop="handleTaskClick(status.value)">
                              <img :src="status.icon" alt="">
                              <span>
                                {{ status.label }}（{{ currentTask.count[status.value] || 0 }}）
                              </span>
                            </div> -->
                            <el-button :type="status.type" plain @click.stop="handleTaskClick(status.value)">{{
                              status.label }}（{{ currentTask.count[status.value]
                              || 0 }}）</el-button>
                          </template>
                          <NodeTaskTable v-if="currentTaskTable && currentTaskTable.length" :item_data="item_data"
                            :tableData="currentTaskTable" @selectData="selectData" />
                          <el-empty v-else description="暂无数据" />
                        </el-popover>
                      </template>
                    </template>
                  </div>
                </div>
              </template>






              <div class="cell_container" v-if="!isDisabled">
                <!--   <div>导入上一步的数据:</div> -->
                <div class="form_container">
                  <LineForms ref="nodeLineForm" :filtered_data="getFilteredLineData(item)" :raw_item="item"
                    @change="handleFormChange"></LineForms>
                </div>
                <!-- <div>本节点参数:</div> -->
                <div class="flex">
                  <!-- <img src="./comps/set.png" alt=""> -->
                  <el-icon size="20px">
                    <Setting />
                  </el-icon>
                  <span style="display: inline-block;margin-left: 12px;font-size: 18px;color: #333;">参数调整</span>
                </div>
                <div class="form_container" style="margin-top: 28px;">
                  <NodeForms ref="nodeForm" :filtered_data="getFilteredData(item)" :raw_item="item"
                    :associate_config="associate_config"></NodeForms>
                </div>
                <div style="text-align: center; margin: 15px 0; padding: 0 20px; box-sizing: border-box;">
                  <el-button type="primary" size="large" style="border-radius: 30px;padding: 0 56px;"
                    @click="openHandle">提交分析任务</el-button>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </template>
      </div>
    </div>

    <div v-loading="is_com_loading" style="margin-top:40px;">
      <!-- <div style="color: red;">当前节点是什么组件 {{ item.type }}</div>
      <div style="color: red;">当前节点title {{ item.title }}</div> -->
      <component :is="components[item.type]" :data="item" :task_result="task_result" />
    </div>


    <template v-if="item.notes && item.notes.length">
      <template v-if="store.app_id">
        <div>
          <p class="section_text" v-for="(e, i) in filteredNotes" :key="i">{{ e }}</p>
        </div>
      </template>
      <template v-else>
        <template v-for="(note, i) in item.notes" :key="i">
          <p v-if="/^注[:：]/.test(note)" class="section_text">{{ note }}</p>
          <template v-else-if="/^结果目录[:：]/.test(note)">
            <a v-if="getPath(note)" class="section_text" @click="openLink(getPath(note))">{{ note }}</a>
            <p v-else class="section_text">{{ note }}</p>
          </template>
          <p v-else class="section_text">{{ note }}</p>
        </template>
      </template>
    </template>


    <div style="margin-top:15px;">
      <ResultsDirectory :filtered_data="getFilteredResultData(item)"></ResultsDirectory>
    </div>

    <el-dialog title="提示" v-model="is_dialog" width="500px">
      <div style="width: 255px;margin: 0 auto;">
        <el-form label-position="top" label-width="300px">
          <el-form-item label="任务名称:">
            <el-input style="width:220px" v-model="task_name" placeholder="请输入任务名称"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <el-button @click="dialogCancel" size="small">取 消</el-button>
        <el-button type="primary" @click="submitFun" :loading="is_submit_loading" size="small">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
  import { ref, computed, markRaw, defineProps, watch, onBeforeMount, onMounted, onBeforeUpdate, onUpdated, onBeforeUnmount, onUnmounted, defineEmits } from 'vue';
  import { ElMessage } from 'element-plus';
  import { useStore } from '@/Store/index.js';
  import PubSub from 'pubsub-js';
  import { findMatchingFormEntries, findMatchingLineEntries, findMatchingResultEntries, restoreFormKeys } from '@/utils/tool.js';
  import { get_report_task_list, start_task, get_node_history_data } from '@/api/index.js';
  import NodeForms from './comps/NodeForm.vue'; //节点表单
  import LineForms from './comps/LineForm.vue';//节点连线表单
  import ResultsDirectory from './comps/ResultsDirectory.vue'; //结果目录
  import HistorySwitch from '@/components/HistorySwitch/index.vue';//历史记录切换
  import TextCom from './comps/TextCom.vue'; //文本
  import ComparisonGroup from '@/components/ComparisonGroup/index.vue';//比较组
  import ImageCom from '@/components/ImageCom/index.vue'; //静态文件组件
  import HtmlCom from './comps/HtmlCom.vue';
  import TableCom from '@/components/TableCom/index.vue';
  import PdbeCom from './comps/PdbeCom.vue';
  import { useTaskStore } from "@/Store/task.js";
  import NodeTaskTable from "./comps/NodeTaskTable.vue";



  const store = useStore();
  const emit = defineEmits([])
  const props = defineProps(['item_data', 'input_json', 'output_json', 'task_result']);

  const taskStore = useTaskStore();
  const lastFetchTime = ref(0); // 记录上一次请求的时间戳


  // 提取路径部分：去掉“结果目录:”或“结果目录：”
  const getPath = (note) => note.replace(/^结果目录[:：]/, '').trim()
  /**
   * 判断是否为相对路径
   * - 支持 ./、../、/开头但不是 // 的路径
   * - 排除 http、https、file 开头
   */
  const isLocalPath = (path) => {
    if (!path) return false
    return /^(\.|\/(?!\/))/.test(path) && !/^(https?:\/\/|file:\/\/)/i.test(path)
  }



  const statusList = [
    {
      value: "Succeeded",
      label: "成功",
      icon: require("@/assets/task_status_1.png"),
      class: "status_btn1",
      type: "success"
    },
    {
      value: "Running",
      label: "进行中",
      icon: require("@/assets/task_status_2.png"),
      class: "status_btn2",
      type: "primary"
    },
    {
      value: "Failed",
      label: "失败",
      icon: require("@/assets/task_status_3.png"),
      class: "status_btn3",
      type: "danger"
    }
  ];


  // 组件名称映射
  const components = {
    "TextCom": TextCom,// 文本
    "ComparisonGroup": ComparisonGroup, // 比较组
    "ImageCom": ImageCom, // 静态文件组件
    "HtmlCom": HtmlCom, //html组件
    "TableCom": TableCom, //表格组件
    "PdbeCom": PdbeCom //pdb组件
  };

  const node_task_name = ref(null);

  const activeNames = ref(1);//当前激活的tab索引
  const table_data = ref(null);//节点历史纪录
  const task_name = ref(`task_name_${new Date().getTime()}`);//本次节点任务名称
  const is_multi_step = ref(false);//是否多步任务
  const is_submit_loading = ref(false);//是否正在提交
  const item = ref(null);//当前节点数据
  const is_dialog = ref(false);//是否显示对话框
  const is_com_loading = ref(false);//是否正在执行组件
  const is_online = ref(false);//是否在线
  const isDisabled = ref(false);//是否禁用按钮
  const associate_config = ref(null);//关联配置

  const nodeForm = ref(null);//表单
  const nodeLineForm = ref(null);//节点连线表单

  /* 
    const formattedData = computed(() => {
  const { columns, data } = taskStore.group_data;
  if (!columns || !data) return [];
  return data.map((row) => {
    const rowObj = {};
    columns.forEach((col, idx) => {
      rowObj[col] = row[idx];
    });
    return rowObj;
  });
});
  */



  /*  const currentTask = computed(() => {
     return taskStore.all_task_data[node_task_name.value] || null;
   }); */

  const currentTask = ref(null);
  const currentTaskTable = ref(null);



  const initFunc = function () {
    if (item.value.process_report.length > 0) getTasks();
  };


  const getTasks = function () { //获取单个任务节点结果--清单
    const task_id = store.task_id;
    if (task_id) {
      const params = {
        task_id,
        "task_name": item.value.process_report[0].task_name
      };
      get_report_task_list(params).then((result) => {

        console.log("获取节点任务数量", result);

        table_data.value = result.data || null;
      }).catch((err) => {
        console.error('获取任务结果失败', err);
      });
    }
  };

  ////计算每个节点的过滤数据
  const getFilteredData = () => findMatchingFormEntries(props.input_json, item.value.process_report);
  //每个节点的连线参数
  const getFilteredLineData = () => findMatchingLineEntries(props.input_json, item.value.process_report);
  //计算节点的结果目录数据
  const getFilteredResultData = () => findMatchingResultEntries(props.output_json, item.value.process_report);


  const openHandle = async function () {
    try {// 先触发表单校验
      let valid = await nodeForm.value.validateForm();
      if (valid) is_dialog.value = true;
    } catch (error) {
      console.error('表单校验未通过');
      ElMessage.error('表单校验失败！');
    }
  };

  const submitFun = function () {
    startNodeTask();
  };

  const dialogCancel = function () {
    is_submit_loading.value = false;//关闭提交按钮
    is_dialog.value = false;//关闭对话框
  };

  const startNodeTask = function () {//启动单节点
    const process_form = store.process_form || {};//流程表单数据
    const node_line_form = nodeLineForm.value.formValues;//节点连线数据
    const node_form = nodeForm.value.formValues;//节点表单数据,被转化了,需要还原
    const app_id = store.app_id;//应用id
    const task_id = store.task_id;//任务id
    const params = {
      "input_data": { ...process_form, ...restoreFormKeys(node_form), ...node_line_form },
      "task_name": task_name.value,
      "node_name": item.value.process_report[0].task_name,
      "app_id": app_id,
      "task_id": task_id
    };
    is_submit_loading.value = true;
    start_task(params).then((result) => {
      if (result.code == 200) {
        ElMessage.success(result.message.tip);
        store.setTaskId(result.message.id);
        getTasks();
        is_submit_loading.value = false;
        is_dialog.value = false;
      }
    }).catch((err) => {
      is_submit_loading.value = false;
      is_dialog.value = false;
    });
  };

  const selectData = function (val) {
    getNodeData(val);
  };

  const getNodeData = function (val) { //获取历史详情

    console.log('获取历史详情', val);

    const task_id = store.task_id;
    if (task_id) {
      const params = {
        "parent_id": task_id,
        "task_id": val.id,
        "task_name": item.value.process_report[0].task_name,
        "title": item.value.title,
        "category_name": store.category_name,
      };
      get_node_history_data(params).then((result) => {
        //判断 result 是对象且有值
        if (result && typeof result === 'object' && Object.keys(result).length > 0) {
          const history_result = { inputs_json: val.input_f, result: result };
          PubSub.publish(item.value.title, history_result);
          //记录当前的节点是哪个历史任务,用作下载报告
          PubSub.publish('history_data', val);
        };
        is_com_loading.value = false;
      }).catch((err) => {
        console.error("error", err);
        is_com_loading.value = false;
      });
    }
  };

  const handleFormChange = function (val) {
    associate_config.value = val;
  };

  // 
  const handleTaskClick = async function (status) {

    /*   getTasks(); */


    const task_id = store.task_id;
    if (task_id) {
      const params = {
        task_id,
        "task_name": item.value.process_report[0].task_name
      };
      get_report_task_list(params).then((result) => {
        currentTask.value = result;
        if (!currentTask.value) return;
        currentTaskTable.value = currentTask.value.data.filter(item => item.status === status);
      }).catch((err) => {
        console.error('获取任务结果失败', err);
      });
    }

    /* 
        let allTaskData = await taskStore.fetchTaskListAll(store.task_id);  // 自动带节流
        console.log("allTaskData", allTaskData);
        currentTask.value = allTaskData[node_task_name.value];
        if (!currentTask.value) return;
        currentTaskTable.value = currentTask.value.data.filter(item => item.status === status); */
  };


  const openLink = function (path) {
    if (!path) return;
    //打开新页面
    window.open(path, "_blank");
  };


  //测试notes数据
  const testNotes = [
    "注：本节点为测试节点，仅用于测试，请忽略。",
    "结果目录：/home/user/result/test_result.txt",
    "结果目录：/home/user/result/test_result2.txt",
    "注：本节点为测试节点，仅用于测试，请忽略。",
    "结果目录：/home/user/result/test_result3.txt",
    "注：本节点为测试节点，仅用于测试，请忽略。",
    "结果目录：/home/user/result/test_result4.txt",
    "注：本节点为测试节点，仅用于测试，请忽略。",
    "结果目录：/home/user/result/test_result5.txt",
    "注：本节点为测试节点，仅用于测试，请忽略。",
    "结果目录：/home/user/result/test_result6.txt",
    "注：本节点为测试节点，仅用于测试，请忽略。",
    "结果目录：/home/user/result/test_result7.txt",
  ]

  const filteredNotes = computed(() =>
    item.value?.notes?.filter(n => !/^结果目录[:：]/.test(n)) || []
    // testNotes?.filter(n => !/^结果目录[:：]/.test(n)) || []
  );


  //组件即将挂载
  onBeforeMount(() => {
    
    item.value = JSON.parse(JSON.stringify(props.item_data));
  });


  // let observer = null;

  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) { // 进入视口
      console.log("进入节点头部");

      //is_online && item.process_report.length>0 && item.process_report[0].task_name
      if (is_online.value && item.value.process_report.length > 0 && item.value.process_report[0].task_name) {
        console.log("对应区域");
        handleTaskClick('Running');
      }

      observer.disconnect(); // 避免重复监听
    };
  }, { threshold: 0.1 });

  const nodeOperationRef = ref(null);

  //组件已经挂载
  onMounted(() => {
    node_task_name.value = props.item_data?.process_report[0]?.task_name;
    currentTask.value = taskStore.all_task_data[node_task_name.value];
    if (item.value.process_report.length > 0) {
      const can_it_run = item.value.process_report[0].can_it_run;
      if (can_it_run && can_it_run == '0') {
        isDisabled.value = true;
      } else {
        isDisabled.value = false;
      };
    };
    const app_id = store.app_id;
    is_online.value = app_id ? true : false;//是否在线

    /*  observer.observe(nodeOperationRef.value); */
    if (nodeOperationRef.value) {
      observer.observe(nodeOperationRef.value);
    }

  });

  onBeforeUnmount(() => {
    observer.disconnect();
  });

</script>
<style lang="scss" scoped>
  .line_title_box {
    margin-top: 30px;
    margin-bottom: 10px;
  }

  .section_text {
    font-size: .87rem;
    text-indent: 2em;
    margin-bottom: 10px;
    line-height: 1.7;
  }

  a.section_text {
    color: var(--el-color-primary);
    text-decoration: underline;
    cursor: pointer;
  }

  .line_history_box {
    height: 48px;
    line-height: 48px;
    background-color: #fff;
    border-top: 1px solid #EBEEF5;
    border-bottom: 1px solid #EBEEF5;
  }

  .collapse_head {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .collapse_h_left .header-icon {
    font-size: 1.3rem;
    vertical-align: middle;
  }

  .collapse_h_left span {
    vertical-align: middle;
  }

  .collapse_h_right {
    cursor: pointer;
    font-size: 13px;
  }


  .custom_collapse_item {
    /* 鼠标事件禁用 */
    pointer-events: none;
  }

  .custom_collapse_item .collapse_h_left i,
  .custom_collapse_item .collapse_h_left span {
    display: none;
  }

  .custom_collapse_item .el-collapse-item__arrow {
    display: none;
  }


  .cell_container {
    width: calc(100% - 30px);
    margin: 0 auto;
    max-height: 400px;
    overflow-y: auto;
  }

  .form_container {
    width: calc(100% - 30px);
    margin: 0 auto;
  }


  .custom_collapse_title {
    width: calc(100% - 50px);
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title_text {
      color: var(--el-color-primary);
      font-size: 18px;
      display: inline-block;
      margin-left: 12px;
    }
  }

  .status_btn {
    font-size: 16px;
    font-weight: 400;
    padding: 0 16px;
    height: 39px;
    border: 1px solid;
    border-radius: 6px;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .status_btn1 {
    color: #5cb85c;
    border-color: #5cb85c;
  }

  .status_btn2 {
    color: #3F6CAF;
    border-color: #3F6CAF;
  }

  .status_btn3 {
    color: #AF3F3F;
    border-color: #AF3F3F;
  }

  :deep(.el-collapse-item__wrap) {
    border: none;
  }

  :deep(.el-collapse-item__header) {
    /* border: none !important; */
    border-bottom: none;
  }

  :deep(.el-collapse) {
    border: none;
  }



  @media screen and (max-width: 1400px) {
    .custom_collapse_title {
      .custom_col_label {
        img {
          width: 16px;
        }

        span {
          font-size: 14px;
        }
      }

      .status_btn {
        height: 30px;
        line-height: 30px;
        padding: 0 10px;
        font-size: 14px;

        img {
          width: 14px;
        }
      }
    }
  }
</style>
<style>
  .cell_container .el-select {
    width: 100%;
  }
</style>